<template>
  <FloatingCard class="stack" :feeling="feeling">
    <TextField
      v-model="url"
      type="url"
      :label="label"
      :helper="helper"
      :feeling="feeling"
      :placeholder="placeholder"
      id="flexi-url"
      @blur="tryConnection"
    />
  </FloatingCard>
</template>

<script>
import TextField from '@/components/TextField';
import FloatingCard from '@/components/FloatingCard';

import Flexi from '@/mixins/Flexi';

export default {
  name: 'FlexiHealthCheckCard',
  components: {
    TextField,
    FloatingCard,
  },
  mixins: [
    Flexi,
  ],
  props: {
    apiURL: {
      type: String,
    },
  },
  data() {
    return {
      status: null,
      url: null,
      version: null,
      label: 'Adresa Flexi',
      placeholder: 'https://demo.flexibee.eu',
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'checking-status':
          return 'pending';
        case 'flexi-available':
          return 'positive';
        case 'flexi-unavailable':
          return 'negative';
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
    helper() {
      switch (this.status) {
        case 'checking-status':
          return `Zkoušíme se připojit k Flexi na adrese ${this.url}`;
        case 'flexi-available':
          return `Skvěle, jsme připojeni 👍 Používáte Flexi verze ${this.version}.`;
        case 'flexi-unavailable':
          return 'Nepodařilo se připojit k Flexi. Zkontrolujte adresu a nezapomeňte na port.';
        case 'something-wrong':
          return 'Něco se pokazilo, ozvěte se nám prosím';
        default:
          return 'Zadejte adresu, na které se přihlašujete do Flexi';
      }
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
    },
  },
  methods: {
    async tryConnection() {
      if (this.url) {
        if (!/^https:\/\//.test(this.url)) {
          this.url = `https://${this.url}`;
        }

        try {
          this.status = 'checking-status';
          const status = await this.$_Flexi_tryConnection({ apiURL: this.url });
          if (status) {
            this.version = status.version;
            this.status = 'flexi-available';
          } else {
            this.version = null;
            this.status = 'flexi-unavailable';
          }
        } catch (error) {
          this.status = 'something-wrong';
          throw error;
        }
      } else {
        this.status = null;
      }
    },
  },
  mounted() {
    this.url = this.apiURL;
    if (this.url) {
      this.tryConnection();
    }
  },
};
</script>
